<template>
  <div class="text-center">
    <v-dialog persistent v-model="visible" width="600">
      <v-card class="not-margin pt-0 pr-0 pl-0">
        <v-toolbar dark color="primary">
          <div class="text-center">
            <v-icon>mdi-eye</v-icon> Visualizar Setor
          </div>
        </v-toolbar>
        <div class="container dialog">
          <v-row class="justify-center mt-7">
            <v-col cols="12">
              <v-text-field
                :value="content.nome"
                label="Setor"
                readonly
                outlined
                dense
              ></v-text-field>
              <v-text-field
                :value="content.origem.nome.toUpperCase()"
                label="Origem"
                readonly
                outlined
                dense
              ></v-text-field>
              <v-select
                v-model="content.funcoes"
                label="Cargos/Funções*"
                outlined
                multiple
                return-object
                item-text="nome"
                item-value="id"
                chips
                readonly
                :items="funcoes"
              ></v-select>
            </v-col>
          </v-row>
        </div>
        <div class="btn-group text-center">
          <v-btn color="primary" @click="$emit('onClose')">
            Fechar
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { DialogProps } from '~/commons/classes/dialog-props';
import { Setor } from '~/commons/classes/setor';

export default {
  props: {
    ...new DialogProps(Setor),
    funcoes: {
      type: Array,
      default: () => [],
    },
  }
}
</script>